import makeStyles from "@mui/styles/makeStyles";

const Style = makeStyles(() => ({
  animatedItem: {
    height: 64,
    width: 64,
    animation: "$spinner 1s linear infinite",
  },
  text: {
    marginTop: 20,
    color: '#fff !important'
  },
  root: {
    background: 'transparent !important',
    boxShadow: 'none !important',
  },
  "@keyframes spinner": {
    from: {
      transform: "rotate(0deg)",
    },
    to: {
      transform: "rotate(360deg)",
    },
  },
}));

export default Style;
